export default {
  methods: {
    durationTime (value, { abbr = true } = {}) {
      const seconds = Math.round(parseFloat(value) || 1)
      let minutes = seconds / 60
      if (minutes >= 1) {
        minutes = Math.round(minutes)
      } else {
        minutes = 0
      }
      const hours = Math.floor(minutes / 60)
      if (hours) {
        minutes = minutes - (60 * hours)
      }

      let text = `${seconds} ${abbr ? 's' : this.$t('SECONDS')}`

      if (minutes) {
        text = `${minutes} ${abbr ? 'min' : this.$t('MINUTES')}`
      }

      if (hours) {
        const oldText = text
        text = `${hours} ${abbr ? 'h' : this.$t('HOURS')}`
        if (minutes) {
          text += ` ${oldText}`
        }
      }

      return text
    }
  }
}
